import { useState, useEffect, useMemo } from "react";
import { shuffle } from "lodash";

import { useRecord, useRecords } from "@latticexyz/stash/react";
import mudConfig from "contracts/mud.config";
import { stash } from "../../../mud/stash";
import { useSessionPlayer } from "../../../SessionPlayerContext";

import { secretCfg } from "../../../config.js";

import { useGuide } from "../../GuideContext";

import MainButton from "../../../components/MainButton";
import { ShowSecret } from "../../../components/ShowSecret";
import { GameWon } from "../../../components/GameWon";
import { hasBeenMoreThanADay } from "../../../utils.js";

import { textConst, getGuideText, getChronicleTypeComment } from "../../../text";

import ExtraAudio from "../../../ExtraAudio.js";

import  "../../../assets/styles/state-roll.css";

const RollInterface = ({seeds, selected=false, onChange=()=>{}}) => {
  const allSeeds = Array.from({ length: 1000 }, (value, index) => index + 1 );
  const randomAvailableSeed = seeds[Math.floor(Math.random() * seeds.length)].seed;
  const [currentChecked, setCurrentChecked] = useState( (selected) ? selected : randomAvailableSeed);
  const [showSecret, setShowSecret] = useState( false );
  const [showWon, setShowWon] = useState( false );

  useEffect( () => {
    if( selected ){
      setCurrentChecked( selected )
    }
  }, [selected])

  useEffect( () => {
    onChange( currentChecked );
  }, [])

  return <>
    <div className="roll-interface fango-border">
      {allSeeds.map( (id) => {
        const available = seeds.find( ( seed ) => {
          return seed.seed === id;
        });
        return <label key={id} className={`roll-item${!available ? ' disabled':  ''}`}><input
          type="radio" 
          value={id} 
          disabled={!available} 
          onChange={ ( e ) => { 
            ExtraAudio.sfxSample('click');
            setCurrentChecked( parseInt(e.target.value) );
            onChange( e.target.value );
          }}
          checked={ parseInt(id) === parseInt(currentChecked) }
        ></input>
          <div className="seed-selection">
            <span>{id}</span>
          </div>
        </label>
      })}
      {/* {secretSeeds.map( (id) => {
        return <label 
          key={id} 
          className={`roll-item`}
        >
          <div className="seed-selection">
            <button
              type="button" 
              onClick={() => {
                ExtraAudio.sfxSample('click');
                setShowSecret( id );
              }}
            >
              {secretCfg.symbols[id]}
            </button>
          </div>
        </label>
      })}  */}
    </div>
    {/* {(showSecret !== false)
      ? <ShowSecret 
          onClose={()=>{
            setShowSecret( false );           
            setShowWon( true );
            alert('winer')
          }}
          text={secretCfg.texts[showSecret]}
        />
      : ''
    } */}
    {(showWon) ? <GameWon onClick={()=>{ setShowWon( false ) }}/> : '' }
  </>
}

/*pick from all numbers without info */
const RollChurch = ( {seeds, onChange=()=>{}} ) => {  
  return <RollInterface seeds={seeds} onChange={onChange} />
}



/* get 3 numbers to select from */
const RollRadical = ( {seeds, onChange=()=>{}} ) => {
  const [choices, setChoices] = useState(shuffle( seeds ).slice( 0, 3 ));  
  return  <RollInterface seeds={choices} onChange={onChange} />
}

/* keep rolling until you get a number you like */
const RollWolf = ( {seeds, onChange=()=>{}} ) => {
  const [selectedSeed, setSelectedSeed] = useState( [shuffle( seeds )[0]] );
  return (
    <>
      <RollInterface
        selected={selectedSeed[0].seed}
        seeds={selectedSeed}
        onChange={onChange}
      />
      <MainButton
        className="roll-wolf-shuffle-btn"
        name={`Grab a different one`}
        onClick={ () => {
          const newId = shuffle( seeds )[0];
          setSelectedSeed( [newId] );
          onChange(newId.seed);
        } }
      />
    </>
  )
}

export const StateRoll = ({
  shouldRender,
  onRollComplete=()=>{},
  onRollFail=()=>{}
}) => {
  const { address: userAddress, updatePlayer } = useSessionPlayer();

  const [seedId, setSeedId] = useState( -1 );

  const player = (userAddress) ? useRecord({
    stash, 
    table: mudConfig.tables.Player, 
    key: { counterValue: userAddress } 
  }) : false;

  const [hasShownRollInstruction, setHasShownRollInstruction] = useState((player) ? player.hasWritten : false );

  const playerFaction = (player) ? useRecord({
    stash, 
    table: mudConfig.tables.Fraction, 
    key: { counterValue: player.fraction } 
  })?.fractionName : false;

  const playerTimes = (userAddress) ? useRecord({
    stash,
    table: mudConfig.tables.PlayerTimes,
    key: { counterValue: userAddress }
  }) : false;

  const isInitiallyTimeout = (playerTimes) ? !hasBeenMoreThanADay( new Date().getTime(), parseInt( playerTimes.lastRoll ) * 1000 ) : false;

  const playerHasSeed = !!player.currentSeedNumbers[0];

  // const playerHasSeed = useStore( ({ getValue, getRecords }) => {
  //   /* TODO: should be able to do this: */
  //   const player = getValue(tables.Player, {key: playerEntity});
  //   // return !!player.currentSeedNumbers[0];
  //   /* but currently the seed remains in the player table so we do: */
  //   const playerCurrentSeed = player.currentSeedNumbers[0];    
  //   const allStoriesByPlayer = Object.values(getRecords( tables.StoryPart )).filter( (story) => story.value.author === playerEntity );
  // });

  const players = useRecords({ 
      stash, 
      table: mudConfig.tables.Player 
    });
    
  const playersSorted = players
    .filter( ( record ) => {
      return record.wonAt > 0;
    })
    .sort( (a, b) => {
      return parseInt(b.wonAt) - parseInt(a.wonAt);
    });    

  const secretHolder = ( playersSorted.length > 0 ) ? playersSorted[0] : false;

  const allStorySeeds = useRecords({
    stash,
    table: mudConfig.tables.StorySeed
  });

  const availableStorySeeds = Object.values(allStorySeeds).filter( (seed) => seed.ownership === "0x0000000000000000000000000000000000000000" );

  const seedsAvailable = availableStorySeeds.length > 0;

  const randomSeedId = () => {
    return availableStorySeeds[ Math.floor( Math.random() * availableStorySeeds.length ) ].seed;
  }

  const {guideState, setGuideState} = useGuide();
  useEffect(() => { 
    if( shouldRender ){

      if( !hasShownRollInstruction ){
        setGuideState({
          ...guideState,
          statement: (isInitiallyTimeout)
            ? getGuideText(
                playerFaction,
                textConst.ROLLTIMEOUT,
                [{find: '<username>', replace: player.name}]
              ) 
            : getGuideText(
                playerFaction,
                textConst.ROLLINSTRUCTION,
                [
                  {find: '<username>', replace: player.name},
                  {find: '<latestsecretholder>', replace: secretHolder}
                ]
              )
        })
      } else {
        setGuideState({
          ...guideState,
          statement: ''
        })
      }

      setHasShownRollInstruction( true );
    }
  },[ shouldRender ]);

  const rollForChronicle = async (seedId: number) => {
    updatePlayer({ currentSeedNumbers: [seedId] });
  };

  if( isInitiallyTimeout ){
    return <div
      className="game-state game-state__roll"
      style={{
        display: (shouldRender) ? 'block' : 'none'
      }}
    ></div>
  }

  return <>
    <div 
      className="game-state game-state__roll"
      style={{
        display: (shouldRender) ? 'block' : 'none'
      }}
    >
        {( !playerHasSeed && playerFaction === 'Church')
          ? <RollChurch 
              seeds={availableStorySeeds}
              onChange={(id) => {
                setSeedId(id);
              }}
            />
          : ''
        }
        {( !playerHasSeed && playerFaction === 'Radical')
          ? <RollRadical 
              seeds={availableStorySeeds}
              onChange={(id) => {
                setSeedId(id);
              }}
            />
          : ''
        }
        {( !playerHasSeed && playerFaction === 'Wolf')
          ? <RollWolf
              seeds={availableStorySeeds}
              onChange={(id) => {
                setSeedId(id);
              }}
            />
          : ''
        }
        {(playerHasSeed)
          ? 'You already have a chronicle, write the story for that.'
          : (seedsAvailable)
            ? <><MainButton
              className="roll-select-btn"
              disabled={seedId === -1} 
              name={`Open chronicle${(seedId > -1) ? ` ${seedId}` : ``}`}

              onClick={ () => {
                  rollForChronicle( seedId );
                  ExtraAudio.sfxSample('page');
                  onRollComplete();
              }}
            />
            </>
            : 'All chronicles have been claimed. Fork an existing story instead'
        }
    </div>
  </>
}